export enum GetGatewayLogParsesRequestTypes {
    Member = 1,
    Invoice = 2,
    AllRecords = 3
}

export class GetGatewayLogParsesRequest {
    GetGatewayLogParsesRequestType: GetGatewayLogParsesRequestTypes;
    ID: number;
    LiveCheckIsSettled: boolean;
}
